import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export const constantRouterMap = [
  {
    path: '/',
    name: 'Index',
    component: () => import('@/views/Index'),
    redirect: '/home',
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import('@/views/home/home')
      },
      {
        path: '/us',
        name: 'us',
        component: () => import('@/views/us/us')
      },
      {
        path: '/login',
        name: 'login',
        component: () => import('@/views/login/login')
      },
      {
        path: '/register',
        name: 'register',
        component: () => import('@/views/login/login')
      },
      {
        path: '/exams',
        name: 'exams',
        component: () => import('@/views/exam/exams')
      },
      {
        path: '/exam-details',
        name: 'exam-details',
        component: () => import('@/views/exam/examDetails')
      },
      {
        path: '/start-exam-a/:id',
        name: 'start-exam-a',
        component: () => import('@/views/exam/startExamA')
      },
      {
        path: '/start-exam-b/:id',
        name: 'start-exam-b',
        component: () => import('@/views/exam/startExamB')
      },
      {
        path: '/exam-record',
        name: 'exam-record',
        component: () => import('@/views/exam/examRecords')
      },
      {
        path: '/knowledge',
        name: 'knowledge',
        component: () => import('@/views/exam/knowledge')
      },
      {
        path: '/courses',
        name: 'courses',
        component: () => import('@/views/exam/courses')
      },
      {
        path: '/course-details',
        name: 'course-details',
        component: () => import('@/views/exam/courseDetails')
      },
      {
        path: '/course-section',
        name: 'course-section',
        component: () => import('@/views/exam/section')
      },
      {
        path: '/account',
        name: 'account',
        component: () => import('@/views/personal/account')
      },
      {
        path: '/password',
        name: 'password',
        component: () => import('@/views/personal/password')
      },
      {
        path: '/incorrect',
        name: 'incorrect',
        component: () => import('@/views/exam/incorrect')
      },
      {
        path: '/reset-password',
        name: 'reset-password',
        component: () => import('@/views/personal/resetPassword')
      },
      {
        path: '/search',
        name: 'search',
        component: () => import('@/views/exam/search')
      },
      {
        path: '/practice/index',
        name: 'practice-index',
        component: () => import('@/views/exam/practice/index'),
        meta: { title: '练习模式' }
      },
      {
        path: '/practice/answer',
        name: 'practice-answer',
        component: () => import('@/views/exam/practice/answer'),
        meta: { title: '答题' }
      },
      {
        path: '/practice/summary',
        name: 'practice-summary',
        component: () => import('@/views/exam/practice/summary'),
        meta: { title: '练习总结' }
      },
      {
        path: '/practice/wrong-questions',
        name: 'practice-wrong-questions',
        component: () => import('@/views/exam/practice/wrong-questions'),
        meta: { title: '错题本' }
      },
      {
        path: '/practice/favorites',
        name: 'practice-favorites',
        component: () => import('@/views/exam/practice/favorites'),
        meta: { title: '我的收藏' }
      },
      {
        path: '/practice/records',
        name: 'practice-records',
        component: () => import('@/views/exam/practice/records'),
        meta: { title: '训练记录' }
      },
      {
        path: '/practice/record-detail',
        name: 'practice-record-detail',
        component: () => import('@/views/exam/practice/record-detail'),
        meta: { title: '记录详情' }
      }
    ]
  },
  {
    path: '/mobile',
    name: 'mobile',
    component: () => import('@/views/mobile/index')
  },
  {
    path: '/mobile-finished',
    name: 'mobile-finished',
    component: () => import('@/views/mobile/finished')
  },
  {
    path: '*',
    redirect: '/home'
  }
]
export default new Router({
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js